import { ListenerPayload } from '@optimizely/optimizely-sdk';

export enum Flags {
  FORCE_CLOSED = 'life-growth_operations_force-closed',
  BANNER_DSS_FLOW_ENABLED = 'life-consumer_operations_banner-dss-enabled',
  HIDE_CALENDLY = 'life-consumer_operations_disable-calendly',
  ADD_TOTAL_HOUSEHOLD_INCOME = 'households_add_total_househould_income',
  ADDITIONAL_CARRIER_DETAILS = 'life-consumer_release_additional_carrier_details',
  EMPLOYMENT_PAGE = 'life-consumer_release_employment_page',
  BANNER_BIRTHPLACE_PAGE = 'life-consumer_release_banner-birthplace-page',
  HAZARDOUS_EMPLOYMENT_QUESTIONS = 'life_consumer_release__hazardous_employment_questions',
  BANNER_SSN_QUESTION = 'life_consumer_release__banner_ssn_question',
  BANNER_APPLICATION_HISTORY_QUESTION = 'life_consumer_release_banner_application_history_question',
  BANNER_DRIVER_HISTORY_PAGE = 'life_consumer_release_banner_driving_history_page',
  BANNER_ALCOHOL_HISTORY_PAGE = 'life_consumer_release_banner_alcohol_history_page',
  ASTHMA_DIABETES_CO_INCLUSION = 'life-consumer_release_asthma-diabetes-co-inclusion',
  DISABLE_LGA_DIGITAL_APPLY = 'life-consumer_release_disable_lga_digital_apply',
  LIFE_FUNNEL_REMIX_P2 = 'life-consumer_life_funnel_remix_p2',
  SPOUSAL_SELF_SERVE = 'life-digital_experiment_spousal-self-serve', // MLD-1 - Remove if Life Spousal Self Serve loses
  SPOUSAL_SELF_SERVE_V2 = 'life_digital_spousal_self-serve_experiment_2_0', // MLD-137 - Remove if Life Spousal Self Serve V2 loses
  MANUAL_DIALER_ADD_FOR_DIGITAL_INELIGIBLE_CUSTOMERS = 'life-digital_manual_dialer_add_for_digital_ineligible_customers',
  OLDER_SEGMENT_INTELLIGENT_ROUTING_EXPERIMENT = 'life-digital_experiment_intelligent-routing-older-segment', // MLD-67 - Remove if Older Segment Intelligent Routing Loses
  OFFBOARD_PARTNER_REFERRAL_TRAFFIC = 'life-digital_experiment_offboard-partner-referral-traffic',
  BUYER_READINESS_V1 = 'life-digital_experiment_buyer-readiness-v1', // MLD-233 - Remove if Buyer Readiness v1 loses
  MULTI_PRODUCT_BASIC_WHOLE_LIFE = 'life-digital_experiment_multi-product-basic-whole-life', // MLD-203 remove after Multi Product Basic Whole Life is settled
  DIGITAL_UPSELL = 'life-digital_experiment_digital-upsell', // MLD-255 remove after Digital Upsell is settled
  DIGITAL_FIRST_ACQUISISTION = 'life-digital_experiment_digital-first-acquisition', // MLD-295 remove after Digital First Acquisition is settled
  DIGITAL_FIRST_ACQUISISTION_V2 = 'life-digital_experiment_digital-first-acquisition-v2', // OA5958-22 remove if Digital First Acquisition V2 lose
  DIGITAL_MULTIPRODUCT_V1 = 'life-digital_experiment_multiproduct_v1', // MLD-333 remove if multi product loses
  SPLIT_FUNNEL_V1 = 'life-digital_experiment_split_funnel_v1', // MLD-365 remove if split funnel loses
  BANNER_HEALTH_HISTORY = 'life-digital_lga_digital_health_history', // MLD-270 remove if Banner E2E loses
  FIELD_UW_UPDATES = 'life-digital_release_digital-field-uw-updated', // MLD-409 remove if field uw updates loses
  SPLIT_FUNNEL_ADJUSTER = 'life-digital_operations_split_funnel', // MLD-421 remove if funnel adjuster loses
  BANNER_E2E_FUNNEL_CHANGES = 'life-digital_release_banner-e2e-funnel-changes', // MLD-426: Remove if we need DL and Family Health History questions back
  HOUSEHOLD_INCOME_UNDER_125K = 'life_digital_experiment_household_income_under_125k', // Feature flag for simplified flow for users under $125k HHI - Optimizely handles income targeting
  HOUSEHOLD_INCOME_OVER_125K = 'life_digital_experiment_household_income_over_125k', // Feature flag for simplified flow for users over $125k HHI - Optimizely handles income targeting
  BANNER_RISETERM_PRODUCT_ENABLED = 'life-consumer_operations_banner-riseterm-enabled',
  INDIVIDUAL_INCOME_OVER_125K = 'life_digital_experiment_individual_income_over_125k', // Feature flag for simplified flow for users with individual income over $125k - Optimizely handles income targeting
  PRUDENTIAL_JOURNEY = 'life_web_prudential_journey', // Feature flag for Prudential Journey
  PRUDENTIAL_HEALTH_DISQUALIFICATION = 'life_web_prudential_health_disqualification', // Prudential disqualification based on health/lifestyle answers (BMI, tobacco, weight change, etc.)
  HOUSEHOLD_INCOME_PAGE_V2 = 'life_revamp_household_income_page_v2', // Household Income Page v2 with removed and updated fields
  SHORTENED_MEDICAL_CONDITIONS_PAGE = 'life_web_default_shortened_medical_page', // Feature flag for shortened medical conditions page - Optimizely handles income targeting
  COVERAGE_GOALS_4_TILE = 'life_web_coverage_goals_page_v2', // Feature flag for coverage goals 4-tile experiment
  PROGRESSIVE_OFFBOARDING = 'enable_progressive_leads', // Feature flag for routing eligible users to Progressive - Optimizely handles state, tobacco, and income targeting
  AI_ASSISTANT_START = 'life_web_ai_assistant_start', // Renders AI assistant on /life-insurance/start when enabled
}

// OA5958-22 remove if Digital First Acquisition V2 lose - START
export enum DigitalFirstV2VariationKeys {
  NUMBER_TIERS = 'number_tiers',
  NAMED_TIERS = 'named_tiers',
  OFF = 'off',
}
// OA5958-22 remove if Digital First Acquisition V2 lose - END

interface FlagDecisionInfo {
  flagKey: string;
  enabled: boolean;
  variationKey: string;
  ruleKey: string;
  variables: Record<string, unknown>;
  reasons: string[];
  decisionEventDispatched: boolean;
}

interface FeatureDecisionInfo {
  featureKey: string;
  featureEnabled: boolean;
  source: string;
  sourceInfo: Record<string, unknown>;
}
interface FlagDecisionListener extends ListenerPayload {
  type: 'flag';
  decisionInfo: FlagDecisionInfo;
}

interface FeatureDecisionInfo {
  featureKey: string;
  featureEnabled: boolean;
  source: string;
  sourceInfo: Record<string, unknown>;
}

interface FeatureDecisionListener extends ListenerPayload {
  type: 'feature';
  decisionInfo: FeatureDecisionInfo;
}

export type DecisionListener = FlagDecisionListener | FeatureDecisionListener;
